import AxiosConfig from '../util/AxiosConfig';
// import history from '../history';
import {
  ACTIVAR_SPINNER_APP,
  // ACTIVAR_SPINNER_MODAL,
  CAMBIAR_STRING_APP,
  // CAMBIAR_STRING_AUTH,
  DESACTIVAR_SPINNER_APP,
  // INVALID_TOKEN,
  // LIMPIAR_ERROR,
  // LIMPIAR_ERROR_MODAL_MENU,
  // MOSTRAR_ERROR,
  MOSTRAR_ERROR_APP,
  // MOSTRAR_ERROR_FORM,
  // MOSTRAR_ERROR_MODAL,
  // OCULTAR_MODAL,
  SET_ARTICULO,
  // SET_DATOS_USER_BASE,
  // SET_TO_INITIAL_VALUES,
  UNSET_ARTICULO,
  // VALIDAR_STRING_APP,
} from '../actions/types';

const gestionErrores = (error, dispatch, textoError) => {
  if (typeof error.response === 'undefined') {
    dispatch({
      type: MOSTRAR_ERROR_APP,
      error: 'Sin conexión',
    });
  } else if (error.response.data.respuesta === 'KO' && (error.response.status === 400 || error.response.status === 401 || error.response.status === 403 || error.response.status === 404 || error.response.status === 500)) {
    dispatch({
      type: MOSTRAR_ERROR_APP,
      error: error.response.data.message,
    });
  } else {
    dispatch({
      type: MOSTRAR_ERROR_APP,
      error: textoError,
    });
  }
};

// export const limpiarErrorModalMenu = () => {
//   return { type: LIMPIAR_ERROR_MODAL_MENU };
// };

export const cambiarStringApp = (propiedad, text) => {
  return {
    type: CAMBIAR_STRING_APP,
    string: { prop: propiedad, value: text },
  };
};

export const checkStatusEnApi = () => {
  return (dispatch) => {
    dispatch({
      type: CAMBIAR_STRING_APP,
      string: { prop: 'status_app', value: 'checking' },
    });

    AxiosConfig.get('auth/check-status', { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (response.data.respuesta === 'OK' && response.data.status === 200 && response.status === 200) {
          dispatch({
            type: CAMBIAR_STRING_APP,
            string: { prop: 'cookie_apc', value: response.data.data.cookieApc },
          });

          dispatch({
            type: CAMBIAR_STRING_APP,
            string: { prop: 'idioma', value: response.data.data.idioma },
          });

          setTimeout(() => {
            dispatch({
              type: CAMBIAR_STRING_APP,
              string: { prop: 'status_app', value: '' },
            });
          }, 500);
        } else {
          dispatch({
            type: MOSTRAR_ERROR_APP,
            error: 'Error inesperado AP001',
          });
        }
      })
      .catch(error => {
        gestionErrores(error, dispatch, 'Error inesperado AP002');
      });
  };
};

export const getArticulosEnAPI = (skip, limit, filtros, arrayArticulos, jump = false) => {
  return (dispatch) => {
    dispatch({ type: ACTIVAR_SPINNER_APP });

    dispatch({
      type: CAMBIAR_STRING_APP,
      string: { prop: 'articulos_cargar_mas', value: true },
    });

    let cadenaFiltro = '__NO__VALE__';
    if (filtros.length !== 0) { cadenaFiltro = filtros.join('::--::'); }

    AxiosConfig.get(`blog/articulos/${skip}/${limit}/${cadenaFiltro}`, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (response.data.respuesta === 'OK' && response.data.status === 200 && response.status === 200) {
          const todosArticulos = arrayArticulos.concat(response.data.articulos);

          if (response.data.articulos.length < limit) {
            dispatch({
              type: CAMBIAR_STRING_APP,
              string: { prop: 'articulos_cargar_mas', value: false },
            });
          }

          dispatch({
            type: CAMBIAR_STRING_APP,
            string: { prop: 'articulos_portada', value: todosArticulos },
          });

          dispatch({
            type: CAMBIAR_STRING_APP,
            string: { prop: 'articulos_skip', value: skip + limit },
          });

          dispatch({ type: DESACTIVAR_SPINNER_APP });

          if (jump === true) {
            setTimeout(() => {
              dispatch({
                type: CAMBIAR_STRING_APP,
                string: { prop: 'articulos_jump', value: true },
              });
            }, 100);
          }
        } else {
          dispatch({
            type: MOSTRAR_ERROR_APP,
            error: 'Error inesperado AP003',
          });
        }
      })
      .catch(error => {
        gestionErrores(error, dispatch, 'Error inesperado AP004');
      });
  };
};

export const aceptarCookies = () => {
  return (dispatch) => {
    AxiosConfig.post(process.env.REACT_APP_URL_COOKIES, { AceptoCookies: 'Acepto', jquery: 'OK' }, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (response.data === 'OK' && response.status === 200) {
          dispatch({
            type: CAMBIAR_STRING_APP,
            string: { prop: 'cookie_apc', value: true },
          });
        } else {
          dispatch({
            type: MOSTRAR_ERROR_APP,
            error: 'Error inesperado AP005',
          });
        }
      })
      .catch(error => {
        gestionErrores(error, dispatch, 'Error inesperado AP006');
      });
  };
};

export const getArticuloEnAPI = (slug) => {
  return (dispatch) => {
    dispatch({ type: ACTIVAR_SPINNER_APP });

    AxiosConfig.get(`blog/articulo/${slug}`, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (response.data.respuesta === 'OK' && response.data.status === 200 && response.status === 200) {
          dispatch({
            type: SET_ARTICULO,
            articulo_titulo: response.data.articulo.titulo,
            articulo_nombre: response.data.articulo.nombre,
            articulo_linkedin: response.data.articulo.linkedin,
            articulo_slug: response.data.articulo.slug,
            articulo_fecha: response.data.articulo.fecha_alta,
            articulo_etiquetas: response.data.articulo.etiquetas,
            articulo_resumen: response.data.articulo.resumen,
            articulo_contenido: response.data.articulo.contenido,
          });

          dispatch({ type: DESACTIVAR_SPINNER_APP });
        } else {
          dispatch({
            type: MOSTRAR_ERROR_APP,
            error: 'Error inesperado AP007',
          });
        }
      })
      .catch(error => {
        gestionErrores(error, dispatch, 'Error inesperado AP008');
      });
  };
};

export const unsetArticulo = () => {
  return { type: UNSET_ARTICULO };
};

// export const validarStringApp = (text, longitud, propiedad, validar) => {
//   const textoValido = text.length;
//
//   if (textoValido >= longitud) {
//     return {
//       type: VALIDAR_STRING_APP,
//       string: { prop: propiedad, value: text },
//       validacion: { prop: validar, value: true },
//     };
//   }
//
//   return {
//     type: VALIDAR_STRING_APP,
//     string: { prop: propiedad, value: text },
//     validacion: { prop: validar, value: false },
//   };
// };
